// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__20ixp","sendOtp":"AuthorizeToLogin_sendOtp__2Uvz1"};